// Session configuration
export const SESSION_VERSION = "1"; // Bump this to force logout all existing users
export const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds
export const ABSOLUTE_TIMEOUT = 8 * 60 * 60 * 1000; // 8 hours in milliseconds

// Initialize session on login
export const initSession = () => {
  const now = Date.now();
  localStorage.setItem("sessionVersion", SESSION_VERSION);
  localStorage.setItem("loginTimestamp", now.toString());
  localStorage.setItem("lastActivity", now.toString());
};

// Update last activity timestamp
export const updateLastActivity = () => {
  localStorage.setItem("lastActivity", Date.now().toString());
};

// Clear all session data
export const clearSession = () => {
  localStorage.clear();
};

// Check if session is valid
export const isSessionValid = () => {
  const token = localStorage.getItem("token");
  const sessionVersion = localStorage.getItem("sessionVersion");
  const loginTimestamp = localStorage.getItem("loginTimestamp");
  const lastActivity = localStorage.getItem("lastActivity");

  // No token = not logged in
  if (!token) {
    return { valid: false, reason: "no_token" };
  }

  // Session version mismatch = force logout (old session)
  if (sessionVersion !== SESSION_VERSION) {
    return { valid: false, reason: "version_mismatch" };
  }

  // Missing session metadata = old session without timestamps
  if (!loginTimestamp || !lastActivity) {
    return { valid: false, reason: "missing_metadata" };
  }

  const now = Date.now();
  const loginTime = parseInt(loginTimestamp, 10);
  const lastActiveTime = parseInt(lastActivity, 10);

  // Check absolute timeout (8 hours since login)
  if (now - loginTime > ABSOLUTE_TIMEOUT) {
    return { valid: false, reason: "absolute_timeout" };
  }

  // Check idle timeout (30 minutes since last activity)
  if (now - lastActiveTime > IDLE_TIMEOUT) {
    return { valid: false, reason: "idle_timeout" };
  }

  return { valid: true, reason: null };
};

// Handle session expiry - clear and redirect
export const handleSessionExpiry = (reason) => {
  clearSession();

  // Optional: You can customize messages based on reason
  const messages = {
    version_mismatch: "Session expired. Please login again.",
    missing_metadata: "Session expired. Please login again.",
    absolute_timeout: "Your session has expired. Please login again.",
    idle_timeout: "You have been logged out due to inactivity.",
  };

  // Store message to show after redirect (optional)
  if (reason && messages[reason]) {
    sessionStorage.setItem("logoutMessage", messages[reason]);
  }

  window.location.pathname = "/";
};
